module.exports = __webpack_public_path__ + "img/Libra.4b59bdeb.svg";